  
const BIS_MIDDLEWARE_URL = 'https://histafood.vercel.app/api/back-in-stock';

let bisCurrentChannel = 'whatsapp';
let bisCurrentProduct = { handle: '', title: '' };

// Popup öffnen
function bisOpen(productHandle, productTitle) {
  bisCurrentProduct = { handle: productHandle, title: productTitle };

  // Produktname setzen
  document.getElementById('bis-product-name').textContent = productTitle;
  document.getElementById('bis-success-product').textContent = productTitle;

  // Formular zurücksetzen
  bisReset();

  // Overlay öffnen
  const overlay = document.getElementById('bis-overlay');
  overlay.classList.add('bis-overlay--open');
  overlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

// Popup schließen
function bisClose() {
  const overlay = document.getElementById('bis-overlay');
  overlay.classList.remove('bis-overlay--open');
  overlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// Kanal wählen
function bisSelectChannel(channel) {
  bisCurrentChannel = channel;

  document.getElementById('bis-card-wa').classList.toggle('bis-card--active', channel === 'whatsapp');
  document.getElementById('bis-card-em').classList.toggle('bis-card--active', channel === 'email');

  document.getElementById('bis-form-whatsapp').classList.toggle('bis-form--active', channel === 'whatsapp');
  document.getElementById('bis-form-email').classList.toggle('bis-form--active', channel === 'email');
}

// Formular absenden
async function bisSubmit(channel) {
  const btn = document.querySelector(`#bis-form-${channel} .bis-btn`);

  // Input holen
  let value = '';
  if (channel === 'whatsapp') {
    value = document.getElementById('bis-phone').value.trim();
    if (!value) return bisShakeInput('bis-phone');
  } else {
    value = document.getElementById('bis-email').value.trim();
    if (!value || !value.includes('@')) return bisShakeInput('bis-email');
  }

  // Loading state
  btn.disabled = true;
  btn.textContent = '...';

  try {
    const res = await fetch(BIS_MIDDLEWARE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        channel: channel,
        phone: channel === 'whatsapp' ? value : undefined,
        email: channel === 'email' ? value : undefined,
        productHandle: bisCurrentProduct.handle,
        productTitle: bisCurrentProduct.title,
      }),
    });

    if (!res.ok) throw new Error('Request failed');

    // Bestätigung zeigen
    const msg = channel === 'whatsapp'
      ? `Sobald ${bisCurrentProduct.title} wieder auf Lager ist, schicken wir dir eine WhatsApp.`
      : `Sobald ${bisCurrentProduct.title} wieder auf Lager ist, schicken wir dir eine E-Mail.`;

    document.getElementById('bis-success-msg').textContent = msg;
    document.getElementById('bis-view-form').classList.add('bis-hidden');
    document.getElementById('bis-view-success').classList.remove('bis-hidden');

  } catch (err) {
    console.error('BIS submit error:', err);
    btn.disabled = false;
    btn.textContent = 'Fehler – bitte erneut versuchen';
    setTimeout(() => {
      btn.textContent = 'Benachrichtige mich';
    }, 3000);
  }
}

// Input schütteln bei leerem Feld
function bisShakeInput(id) {
  const input = document.getElementById(id);
  input.style.borderColor = '#e05a5a';
  input.style.animation = 'bisShake 0.3s ease';
  setTimeout(() => {
    input.style.borderColor = '';
    input.style.animation = '';
  }, 600);
}

// Formular zurücksetzen
function bisReset() {
  document.getElementById('bis-view-form').classList.remove('bis-hidden');
  document.getElementById('bis-view-success').classList.add('bis-hidden');
  document.getElementById('bis-phone').value = '';
  document.getElementById('bis-email').value = '';
  bisSelectChannel('whatsapp');

  // Buttons zurücksetzen
  document.querySelectorAll('.bis-btn').forEach(btn => {
    btn.disabled = false;
    btn.innerHTML = btn.closest('#bis-form-whatsapp')
      ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg> Benachrichtige mich'
      : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg> Benachrichtige mich';
  });
}

// Overlay click = schließen
document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('bis-overlay').addEventListener('click', (e) => {
    if (e.target === document.getElementById('bis-overlay')) bisClose();
  });
});

// ESC = schließen
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') bisClose();
});
